import DatePickerGroup from './DatePickerGroup';
import styled from 'styled-components';

// Styled version
export const StyledDatePickerGroup = styled(DatePickerGroup)`
    display: inline-block;
    vertical-align: middle;
    height: 5.6rem;
    position: relative;
    width: 100%;

    div.datepicker__item {
        width: calc((100% - 1rem) / 2);
        display: inline-block;
        vertical-align: middle;
        min-height: 0;
    }

    div.datepicker__item + div.datepicker__item {
        margin-left: 1rem;
    }
`;

export default StyledDatePickerGroup;
